// @ts-nocheck
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch'
import { createTheme, ThemeProvider } from "@mui/material";
import type { } from "@mui/x-date-pickers-pro/themeAugmentation";
import type { } from "@mui/x-date-pickers/themeAugmentation";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import { App } from "./app";
import "./index.css";
import { config } from "./shared/config";
import { getUserData } from './shared/appInterface';
import "./global.css"

Sentry.init({
    dsn: "https://328cc81059104ba1b3f5cd80d36662f8@o283849.ingest.sentry.io/4504287608504320",
    integrations: [new BrowserTracing()],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0.01,
    environment: config.env
});

try {
    const userData = getUserData();
    Sentry.setUser({
        id: userData?.id,
    });
} catch (error) {
    Sentry.setUser({
        id: "99999",
    });
}

const AutocompletePaperComponent = (props) => (
    <div
        style={{
            boxShadow: "0px 10px 64px rgba(140, 133, 148, 0.2)",
            background: "white",
        }}
        {...props}
    />
);

const theme = createTheme({
    palette: {
        secondary: {
            main: "#1F8268",
        },
        primary: {
            main: "#4d3951",
        },
        mode: "light",
    },
    typography: {
        fontFamily: ['Inter', 'Roboto Flex'].join(','),
    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    boxShadow: "none",
                    textTransform: "none",
                    "&:hover": {
                        boxShadow: "none",
                    },
                    ...(ownerState.variant === "contained" &&
                        ownerState.color === "secondary" && {
                            color: "#fff",
                            textTransform: "none",
                            fontWeight: "600",
                        }),
                }),
            },
            defaultProps: {
                variant: "contained",
                size: "large",
                color: "secondary",
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontSize: "14px",
                    color: "#190A28",
                    fontWeight: "500",
                    lineHeight: "20px",
                    height: "48px",
                    fontFamily: ['Inter', 'Roboto Flex'].join(','),
                },
                input: {
                    marginTop: "-3.5px",
                },
            },
        },
        MuiAutocomplete: {
            styleOverrides: {
                endAdornment: {
                    top: "calc(50% - 14px)",
                },
                option: {
                    fontSize: 14,
                    color: "#190A28",
                    minHeight: 40
                }
            },
            defaultProps: {
                PaperComponent: AutocompletePaperComponent,
            },
        },
        MuiSelect: {
            styleOverrides: {
                select: {
                    fontSize: "16px",
                    color: "#190A28",
                    fontWeight: "500",
                    borderRadius: "4px",
                    lineHeight: "20px",
                },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    fontSize: "16px",
                    color: "#190A28",
                    fontWeight: "500",
                    lineHeight: "20px",
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    marginLeft: "0",
                    "&.Mui-error": {
                        color: "#CB2F67",
                    },
                },
            },
        },
        MuiCalendarPicker: {
            styleOverrides: {
                root: {
                    "& .Mui-selected": {
                        color: "#fff !important",
                    },
                },
            },
        },

        // confirm before commiting
        // MuiInputBase: {
        //     styleOverrides: {
        //         root: {
        //             height: "48px",
        //         },
        //         input: {
        //             height: "48px",
        //             padding: 0,
        //         },
        //     },
        // },
    },
});

const queryClient = new QueryClient();

ReactDOM.createRoot(document.getElementById("app")).render(
    //   <React.StrictMode>
    <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={createTheme(theme)}>
                <App />
        </ThemeProvider>
    </QueryClientProvider>
    //   </React.StrictMode>
);
